import React, { FC } from "react";
import { Switch } from "react-router-dom";
import { UsersFilterProvider } from "../../providers/Users/users-filter-provider";
import { AuthenticatedRoute } from "../../utils/AuthenticatedRoute";
import { AvailableBaseRoutes } from "../../utils/constants";
import { GroupType } from "../../domain/group/group-type";
import { UserListPage } from "../../pages/users/users-list.page";

export const UsersRoutes: FC = () => {
  return (
    <UsersFilterProvider>
      <Switch>
        <AuthenticatedRoute
          path={AvailableBaseRoutes.UserList}
          component={UserListPage}
          allowedRoles={[GroupType.Admin]}
        />
      </Switch>
    </UsersFilterProvider>
  );
};
